import React, { useState } from 'react';
import cx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';
import { Heading } from '@printdeal/ui-library';
import { Image } from '@unpic/react';
import { HeroSearchChat, type RelatedProduct } from './HeroSearchChat';
import { RelatedProducts } from './RelatedProducts';
// @ts-expect-error No types available for image imports
import img from './banner-ai-tool.png';

const GuidedSearchHero: React.FC = () => {
  const intl = useIntl();
  const [recommendedProducts, setRecommendedProducts] = useState<RelatedProduct[]>([]);
  const [isChatting, setIsChatting] = useState(false);

  return (
    <div className={cx('pd-relative pd-flex pd-w-full pd-items-center pd-bg-[#EEF5FD]', {
      'pd-h-[400px]': !isChatting,
    })}
    >
      <div className="pd-container pd-flex pd-w-full pd-content-between pd-items-center">
        <div className="pd-relative pd-grid pd-w-full pd-grid-cols-12 pd-gap-8">
          {/* Title, subtitle and chat section */}
          <div className="pd-relative pd-col-span-12 pd-mt-5 pd-flex pd-flex-col pd-justify-center lg:pd-col-span-7">
            <Heading size="2">
              <FormattedMessage
                id="impressto.homepage.hero.title"
                defaultMessage="Imagine, customize, wear"
              />
            </Heading>
            <Heading as="h2" variant="display" className="pd-mt-2 lg:pd-mt-3">
              <FormattedMessage
                id="impressto.homepage.hero.subtitle"
                defaultMessage="Your vision, our mission."
              />
            </Heading>
            <div className={cx('pd-transition-all pd-duration-300', {
              'pd-pt-[0.625rem]': isChatting,
              'pd-pt-[0.225rem]': !isChatting,
            })}
            >
              <HeroSearchChat
                isChatting={isChatting}
                setRelatedProducts={setRecommendedProducts}
                setIsChatting={setIsChatting}
              />
            </div>
          </div>

          {/* Image section and related products section */}
          <div className="pd-relative pd-z-20 pd-col-span-12 pd-hidden pd-w-full lg:pd-col-span-5 lg:pd-flex lg:pd-items-center lg:pd-justify-end">
            {recommendedProducts.length > 0 ? (
              <RelatedProducts products={recommendedProducts} />
            ) : (
              <div className="pd-flex pd-size-full pd-items-center pd-justify-center">
                <Image
                  className={cx('pd-max-w-xs pd-transition-all pd-duration-300', {
                    'pd-max-w-[500px]': isChatting,
                  })}
                  src={img}
                  layout="constrained"
                  width={800}
                  aspectRatio={1}
                  priority
                  alt={intl.formatMessage({ id: 'impressto.homepage.hero.banner.alt', defaultMessage: 'Impressto homepage banner' })}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidedSearchHero;
